import React, { Component, createRef } from "react";

import //  motion,
  //AnimatePresence,
  "framer-motion";

// Styles
import "./Level.scss";

// Components
import Header from "components/Header";
import Options from "components/Options";
import GameScreen from "../../components/GameScreen";
import PlayIcon from "static/img/playicons.svg";
import Run from "static/img/RUN.svg";
import Antirotate from "static/img/antirotate.svg";
import StopIcon from "static/img/stopBtn.svg";
import Rotate from "static/img/rotate.svg";
import CircularRedCloseIcon from "static/img/circular-red-close-icon.svg";
import Button from "components/Button";
import Welcome from "views/Welcome";
import Tutorial2 from "views/Tutorial2";

// import Popup from "components/Popup";
//import LevelEnd from "components/LevelEnd";

// Icons
//import CircularBlackCrossIcon from 'static/icons/circular-black-cross-icon.svg'
// import RefreshIcon from "static/icons/refresh-icon.svg";
// import SuccessIcon from "static/icons/success-icon.svg";

// Sounds
import { ButtonSound } from "../../utility/sounds";

// Images
//import RotatePhone from "static/img/rotate-phone.gif";
//import Tutorial from "components/Tutorial";
// Constants
import { levelsMap } from "../../utility/levelsData";
import { Timer, GAME_TIME } from "../../utility/Timer";
import { getData } from "services/ApiService";
import { PAUSE_TIMER_EVENT } from "utility/constants";
import { RESUME_TIMER_EVENT } from "utility/constants";
// import { getData } from "services/ApiService";

class Level extends Component {
  constructor(props) {
    super(props);
    let { level } = this.props.location;
    let seconds = window.gameTimer
      ? Math.floor(window.gameTimer.getRemainingTime())
      : Math.floor(GAME_TIME);
    this.state = {
      currentLevel: level ? level : 1,
      currentLevelMap: levelsMap[level ? level - 1 : 0],
      isPlaying: false,
      showStopIcon: false,
      showSkipButton: false,
      showLevelEndPage: false,
      seconds: seconds,
      startCounter: false,
      skipTime: {
        minutes: 3,
        seconds: 30,
      },
      //data for statistics
      timeTakePerLevel: [{ start: seconds, end: null, wasSkipped: false }],
      numberOfResets: 0,
      numberOfSkips: 0,
      //list of moves used in level 1,2,3
      moves: [],
      pastMoves: Array.from({ length: levelsMap.length }).fill([]),
      //total number of play moves
      //number of wrong moves == if level was skipped then same else number of play moves - 1
      numberOfPlayMoves: Array.from({ length: levelsMap.length }).fill(0),
      showTutorial: false,
      levelState: "SUCCESS",
      currentActiveMove: {},
      areMovesDisabled: false,
      gameStats: {},
      efficiency: 0,
      optimism: 0,
      productivity: 0,
      totalTime: 0,
    };
    this.gameRef = createRef();
    this.OptionsRef = createRef();
  }

  intervalCallback = (remainingTime) => {
    const seconds = remainingTime;
    this.setState({ seconds });
  };

  timeOutCallback = () => {
    this.setState({ areMovesDisabled: true });
    this.props.history.replace({
      pathname: "/gamecomplete",
      stats: {
        api: true,
        currentLevel: this.state.currentLevel,
        seconds: this.state.seconds,
        time: this.state.timeTakePerLevel,
        moves: this.state.moves,
        playMoves: this.state.numberOfPlayMoves,
        pastMoves: this.state.pastMoves,
        completed: false,
        total: levelsMap.length,
      },
    });
  };

  async componentDidMount() {
    let { level, seconds, completed, stats } = this.props.location;
    console.log('this.props.location', this.props.location)
    if (level && stats) {
      if (level > levelsMap.length) {
        this.props.history.replace({
          pathname: "/gamecomplete",
          stats: {
            api: false,
            currentLevel: levelsMap.length,
            seconds: seconds,
            time: stats.time,
            moves: stats.moves,
            playMoves: stats.playMoves,
            pastMoves: stats.pastMoves,
            completed: completed,
            total: levelsMap.length,
          },
        });
      }
          this.setState({
        seconds: seconds,
        currentLevel: level,
        currentLevelMap: levelsMap[level - 1],
        timeTakePerLevel: stats.time,
        numberOfResets: stats.resets,
        moves: stats.moves,
        numberOfPlayMoves: stats.playMoves,
        pastMoves: stats.pastMoves,
      });
      if (this.gameRef.current) this.gameRef.current.reset();
    }

    if (!window.gameTimer) {
      window.gameTimer = new Timer(
        seconds ? seconds : GAME_TIME,
        1,
        this.intervalCallback,
        this.timeOutCallback
      );
      window.gameTimer.start();
    } else {
      const seconds = window.gameTimer.getRemainingTime();
      this.setState({ seconds });
      window.gameTimer.resume(this.intervalCallback, this.timeOutCallback);
    }
    if (localStorage.getItem("is_reloaded")) {
      localStorage.removeItem("is_reloaded");
    } else {
      localStorage.setItem("is_reloaded", true);
    }
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
    window.addEventListener("resize", () => {
      let vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    });

    document.querySelector("body").style.overflow = "hidden";
    window.addEventListener(PAUSE_TIMER_EVENT, this.pauseTimer)
    window.addEventListener(RESUME_TIMER_EVENT, this.resumeTimer)
  }

  pauseTimer = () => {
    window.gameTimer.pause()
  }

  resumeTimer = () => {
    window.gameTimer.resume(this.intervalCallback, this.timeOutCallback)
  }

  openNextLevelPopup(val) {
    var value = val;
    this.setState((prevState) => {
      let moves = JSON.parse(JSON.stringify(prevState.moves));
      let timeTakePerLevel = JSON.parse(JSON.stringify(prevState.timeTakePerLevel));
      timeTakePerLevel[prevState.currentLevel - 1].wasSkipped = false;
      timeTakePerLevel[prevState.currentLevel - 1].end = prevState.seconds;
      moves[prevState.currentLevel - 1] = value;
      return {
        timeTakePerLevel: timeTakePerLevel,
        moves: moves,
      };
    });
    this.setState(
      {
        showLevelEndPage: true,
        showSkipButton: false,
        areMovesDisabled: true,
      },
      () => {
        this.OptionsRef.current.emptyMoves();
      }
    );
    let nextLevel = this.getNextLevel();
    if (this.state.currentLevel === levelsMap.length && nextLevel === levelsMap.length) {
      this.getResults();
      let gameStats = {
        time: this.state.timeTakePerLevel,
        efficiency: this.state.efficiency,
        optimism: this.state.optimism,
        productivity: this.state.productivity,
      };
      this.setState({
        levelState: "STATS",
        gameStats: gameStats,
        showSkipButton: false,
      });
      this.props.history.replace({
        pathname: "/gamecomplete",
        stats: {
          api: true,
          currentLevel: this.state.currentLevel,
          seconds: this.state.seconds,
          time: this.state.timeTakePerLevel,
          moves: this.state.moves,
          playMoves: this.state.numberOfPlayMoves,
          pastMoves: this.state.pastMoves,
          completed: true,
          total: levelsMap.length,
        },
      });
    } else {
      this.goToNextLevel();
    }
  }

  getSuccessButton(onClickMethod) {
    return (
      <Button
        onClick={() => onClickMethod(this)}
        className="btn btn__green btn__lg"
        style={{ marginTop: "40px" }}
      >
        Next
      </Button>
    );
  }

  goToNextLevel(_self = this) {
    _self.setState((prevState) => {
      let timeTakePerLevel = JSON.parse(JSON.stringify(prevState.timeTakePerLevel));
      if (prevState.currentLevel < levelsMap.length) {
        timeTakePerLevel.push({
          start: prevState.seconds,
          end: null,
          wasSkipped: false,
        });
      }
      return { timeTakePerLevel: timeTakePerLevel };
    });
    let nextLevel = _self.getNextLevel();
    const intervalCallback = (remainingTime) => {
      const seconds = remainingTime;
      this.setState({ seconds });
    };
    localStorage.setItem("lvl-completed", this.state.currentLevel);
    const timeOutCallback = () => {
      this.setState({ areMovesDisabled: true });
      this.props.history.replace({
        pathname: "/gamecomplete",
        stats: {
          api: true,
          currentLevel: this.state.currentLevel,
          seconds: this.state.seconds,
          time: this.state.timeTakePerLevel,
          moves: this.state.moves,
          playMoves: this.state.numberOfPlayMoves,
          pastMoves: this.state.pastMoves,
          completed: false,
          total: levelsMap.length,
        },
      });
    };
    window.gameTimer.pause(intervalCallback, timeOutCallback);
    this.props.history.replace({
      pathname: "/nextlevel",
      level: nextLevel,
      seconds: this.state.seconds,
      total: levelsMap.length,
      stats: {
        currentLevel: this.state.currentLevel,
        time: this.state.timeTakePerLevel,
        resets: this.state.numberOfResets,
        moves: this.state.moves,
        playMoves: this.state.numberOfPlayMoves,
        pastMoves: this.state.pastMoves,
      },
    });
  }

  getResults = () => {
    //this.TimeInEachLevel();
    /*let numberskipped = 0;
        this.state.timeTakePerLevel.map(
            (i) => {
                console.log(i)
                numberskipped = i.wasSkipped ? numberskipped + 1 : numberskipped
                console.log(numberskipped)
                return numberskipped
            }
        );
        console.log(numberskipped)
        this.setState({
            optimism: ((
                ((levelsMap.length - numberskipped) / levelsMap.length) *
                100
            ).toFixed(0))
        });
        let val = ((240 - this.state.totalTime) / 240) * 100 + 30;
        this.setState({
            efficiency: numberskipped === levelsMap.length ? 0 : val > 100 ? 100 : val < 0 ? 10 : val.toFixed(0),
        });*/
    console.log(this.state.numberOfPlayMoves);
    var NumberOfWrongPlayMoves = 0;
    this.state.numberOfPlayMoves.map((item, index) => {
      NumberOfWrongPlayMoves = NumberOfWrongPlayMoves + item;
      return item;
    });
    let totalLevels = levelsMap.length;
    console.log(totalLevels, NumberOfWrongPlayMoves);
    this.setState({
      productivity: Math.floor((totalLevels / NumberOfWrongPlayMoves) * 100),
    });
  };

  TimeInEachLevel = () => {
    var array = this.state.timeTakePerLevel.map((item, index) => {
      if (item.wasSkipped) {
        return `level ${index + 1} was skipped`;
      }
      if (item.start && item.end && item.start.split(":").length && item.end.split(":").length) {
        var smin = parseInt(item.start.split(":")[0]);
        var ssec = parseInt(item.start.split(":")[1]);
        var emin = parseInt(item.end.split(":")[0]);
        var esec = parseInt(item.end.split(":")[1]);
        var startTime = smin * 60 + ssec;
        var endTime = emin * 60 + esec;
        var diff = startTime - endTime;
        this.setState({ totalTime: this.state.totalTime + diff });
        return `Level ${index + 1} completed in ${Math.floor(diff / 60)}:${diff % 60}`;
      }
      return false;
    });
    return array;
  };

  consoleStats = () => {
    console.log("user statistics");
    console.log("Time Taken Per Level -", this.state.timeTakePerLevel);

    //console.log(this.TimeInEachLevel());
    console.log("Number of resets", this.state.numberOfResets);
    console.log("Number of skips", this.state.numberOfSkips);
    console.log(
      "number of wrong play",
      this.state.numberOfPlayMoves.map((item, index) => {
        return this.state.timeTakePerLevel[index].wasSkipped ? item : item - 1;
      })
    );
    console.log("repeated mistakes", JSON.parse(localStorage.getItem("wrongMoves")));
    console.log("winning moves per level");
    this.state.timeTakePerLevel.map((time, timeIndex) =>
      !time.wasSkipped
        ? console.log(
          `Level ${timeIndex + 1}`,
          JSON.parse(localStorage.getItem(`moves${timeIndex + 1}`))
        )
        : console.log("")
    );
    console.log("empty moves", localStorage.getItem("pressedPlayButtonWithEmptyLoops"));
    console.log("number of undos", localStorage.getItem("undos"));
  };

  getNextLevel() {
    let level = this.state.currentLevel;
    if (level === levelsMap.length) {
      //this.consoleStats();
      this.setState({
        levelState: "STATS",
        showLevelEndPage: true,
        showSkipButton: false,
      });
      return level;
      // level = 1;
    } else {
      level++;
      return level;
    }
  }

  // reInitiateCounter = () => {
  //     this.setState({
  //         startCounter: true,
  //         minutes: 4,
  //         seconds: 0,
  //         showSkipButton: false,
  //     });
  //     this.counter();
  // };
  //
  // counter = () => {
  //     this.setState({startCounter: true});
  //     this.gameTimer = setInterval(() => {
  //         const {seconds, minutes} = this.state;
  //         if (
  //             this.state.seconds === this.state.skipTime.seconds &&
  //             this.state.minutes === this.state.skipTime.minutes
  //         ) {
  //             this.setState({showSkipButton: true});
  //         }
  //         if (seconds > 0) {
  //             this.setState(({seconds}) => ({
  //                 seconds: seconds - 1,
  //             }));
  //         }
  //         if (seconds === 0) {
  //             if (minutes === 0) {
  //                 this.setState({startCounter: false});
  //                 clearInterval(this.gameTimer);
  //                 if (this.props.location.pathname === "/level") {
  //                     //fail screen here
  //                     // this.props.history.push("/");
  //                     if (
  //                         this.state.currentLevel !== levelsMap.length &&
  //                         this.state.levelState === "SUCCESS"
  //                     ) {
  //                         this.setState({
  //                             levelState: "TIME_OUT",
  //                             showLevelEndPage: true,
  //                         });
  //                     }
  //                 }
  //             } else {
  //                 this.setState(({minutes}) => ({
  //                     minutes: minutes - 1,
  //                     seconds: 59,
  //                 }));
  //             }
  //         }
  //     }, 1000);
  // };

  componentWillUnmount() {
    // this.setState({startCounter: true});
    // clearInterval(this.gameTimer);
    document.querySelector("body").style.overflow = "auto";
  }

  getMetaData() {
    return levelsMap[this.state.currentLevel - 1];
    // switch () {
    //   case 1:
    //     return level_1;
    //   case 2:
    //     return level_2;
    //   case 3:
    //     return level_3;
    //   default:
    //     return level_1;
    // }
  }

  getData() {
    return levelsMap[this.state.currentLevel - 1];
    // switch (this.state.currentLevel) {
    //   case 1:
    //     return level_1_data;
    //   case 2:
    //     return level_2_data;
    //   case 3:
    //     return level_3_data;
    //   default:
    //     return level_1_data;
    // }
  }

  PlayMoves = async (val1, val2) => {
    //console.log('Val1', val1, 'Val2', val2);
    this.setState((prevState) => {
      let playMoves = [...prevState.numberOfPlayMoves];
      playMoves[prevState.currentLevel - 1]++;
      return {
        numberOfPlayMoves: playMoves,
      };
    });
    this.setState({ showStopIcon: true });
    await this.gameRef.current.setResetfalse();
    await this.gameRef.current.play(val1, val2);
    this.setState({ isPlaying: false });
  };

  resetLevel = () => {
    let options = this.OptionsRef.current.state;
    if (this.state.numberOfPlayMoves[this.state.currentLevel - 1] >= 1)
      this.setState(({ pastMoves }) => ({
        pastMoves: [
          ...pastMoves.slice(0, this.state.currentLevel - 1),
          [
            ...pastMoves[this.state.currentLevel - 1],
            {
              main: options.mainMoves.length,
              proc: options.loopMoves.length,
              total: options.mainMoves
                .map((move) => (move === "PROCEDURE" ? options.loopMoves.length : 1))
                .reduce((prev, current) => prev + current, 0),
            },
          ],
          ...pastMoves.slice(this.state.currentLevel),
        ],
      }));
    this.gameRef.current.reset();
    this.OptionsRef.current.emptyMoves();
    this.setState({
      showStopIcon: false,
      showLevelEndPage: false,
    });
  };

  stopButtonClickHandler(val = true) {
    val && ButtonSound();
    this.setState({
      showStopIcon: false,
    });
    val && this.gameRef.current.reset();
  }

  GetRemainingTimeAfter30Seconds = () => {
    let currentTimeSeconds = this.state.seconds;
    let currentTimeMinutes = this.state.minutes;
    if (currentTimeSeconds > 30) {
      currentTimeSeconds = currentTimeSeconds - 30;
    } else if (currentTimeSeconds < 30 && currentTimeMinutes >= 1) {
      currentTimeSeconds = 30 + currentTimeSeconds;
      currentTimeMinutes = currentTimeMinutes - 1;
    } else {
      currentTimeSeconds = 30;
      currentTimeMinutes = 4;
    }

    return {
      seconds: currentTimeSeconds,
      minutes: currentTimeMinutes,
    };
  };

  skipLevel = async () => {
    ButtonSound();
    await this.setState((prevState) => {
      let timeTakePerLevel = JSON.parse(JSON.stringify(prevState.timeTakePerLevel));
      timeTakePerLevel[prevState.currentLevel - 1].wasSkipped = true;
      timeTakePerLevel[prevState.currentLevel - 1].end = prevState.seconds;
      if (prevState.currentLevel < levelsMap.length) {
        timeTakePerLevel[prevState.currentLevel].start = prevState.seconds;
      }
      return {
        timeTakePerLevel: timeTakePerLevel,
        numberOfSkips: prevState.numberOfSkips + 1,
      };
    });
    let nextLevel = this.getNextLevel();
    if (this.state.currentLevel === levelsMap.length && nextLevel === levelsMap.length) {
      this.getResults();
      this.setState({
        levelState: "STATS",
        gameStats: {
          efficiency: this.state.efficiency,
          optimism: this.state.optimism,
          productivity: this.state.productivity,
        },
        showSkipButton: false,
      });
    } else {
      this.setState({
        currentLevel: nextLevel,
        currentLevelMap: levelsMap[nextLevel - 1],
        showSkipButton: false,
        skipTime: this.GetRemainingTimeAfter30Seconds(),
      });
      this.resetLevel();
    }
  };

  levelEndNextButtonClickHandler() {
    const { levelState } = this.state;

    if (levelState === "SUCCESS") {
      this.setState(
        {
          areMovesDisabled: false,
        },
        () => {
          this.goToNextLevel();
        }
      );
    } else if (levelState === "TIME_OUT") {
      this.props.history.replace("/");
    } else if (levelState === "STATS") {
      this.props.history.replace("/");
    }
  }

  moveChangeHandler(moveType, method, index) {
    this.setState({
      currentActiveMove: {
        move: moveType,
        method: method,
        index: index,
      },
    });
  }

  tutorialBtnHandler = () => {
    if (!this.state.isPlaying) {
      this.setState((prevState) => ({ showTutorial: !prevState.showTutorial }));
    }
  };

  render() {
    const {
      currentLevel,
      currentLevelMap,
      showStopIcon,
      showSkipButton,
      //showLevelEndPage,
      //levelState,
      currentActiveMove,
      areMovesDisabled,
      //gameStats,
      seconds,
      minutes,
      startCounter,
      showTutorial,
    } = this.state;

    return (
      <>
        <div className="level-layout">
          <Header
            minutes={minutes}
            seconds={seconds}
            startCounter={startCounter}
            currentLevel={currentLevel}
            total={levelsMap.length}
            showSkipButton={showSkipButton}
            skipLevel={this.skipLevel}
            isTutorialPlaying={showTutorial}
            tutorialBtnHandler={this.tutorialBtnHandler}
          />

          <div className="main-container">
            <div className="level-container">
              <img
                src={CircularRedCloseIcon}
                alt="Close icon"
                className="main-card__content--clear-icon"
              />
              {currentLevelMap && (
                <GameScreen
                  ref={this.gameRef}
                  metaData={currentLevelMap.metadata}
                  data={currentLevelMap.data}
                  goToNextLevel={(val) => this.openNextLevelPopup(val)}
                  reset={() => {
                    this.stopButtonClickHandler(false);
                  }}
                  onMoveChange={(moveType, method, index) =>
                    this.moveChangeHandler(moveType, method, index)
                  }
                />
              )}
            </div>
            <div className="options-container">
              <div className="play-container">
                {!this.state.isPlaying && (
                  <Button
                    className="play-btn"
                    onClick={() => {
                      this.gameRef.current.reset();
                      this.OptionsRef.current.playButtonClickHandler();
                    }}
                  >
                    <img src={PlayIcon} alt="Play icon" className="play-icon" />
                    <img src={Run} alt="Play icon" className="play-text" />
                  </Button>
                )}
                {this.state.isPlaying && (
                  <Button
                    className="play-btn stop-btn"
                    onClick={() => {
                      this.gameRef.current.reset();
                    }}
                  >
                    <img
                      src={StopIcon}
                      alt="Play icon"
                    // className="play-text"
                    />
                  </Button>
                )}
                <div>
                  <button
                    className="rotate"
                    style={{ marginRight: "16px" }}
                    onClick={() => {
                      ButtonSound();
                      this.OptionsRef.current.removeMove();
                    }}
                    disabled={this.state.isPlaying}
                  >
                    <img src={Rotate} alt="Play icon" className="rotate-icon" />
                  </button>
                  <button
                    className="rotate"
                    onClick={() => {
                      ButtonSound();
                      this.resetLevel();
                      this.setState({
                        numberOfResets: this.state.numberOfResets + 1,
                      });
                    }}
                    disabled={this.state.isPlaying}
                  >
                    <img src={Antirotate} alt="Play icon" className="rotate-icon" />
                  </button>
                </div>
              </div>
              {currentLevelMap && (
                <Options
                  currentLevel={currentLevel}
                  currentActiveMove={currentActiveMove}
                  procedure={this.state.currentLevelMap.metadata.procedure}
                  ref={this.OptionsRef}
                  PlayMoves={(val1, val2) => this.PlayMoves(val1, val2)}
                  showStopIcon={showStopIcon}
                  onStopClick={() => this.stopButtonClickHandler()}
                  onRefreshClick={() => {
                    ButtonSound();
                    this.resetLevel();
                    this.setState({
                      numberOfResets: this.state.numberOfResets + 1,
                    });
                  }}
                  areMovesDisabled={areMovesDisabled || this.state.isPlaying}
                  begin={() => this.setState({ isPlaying: true })}
                  runBot={() => {
                    this.gameRef.current.reset();
                    this.OptionsRef.current.playButtonClickHandler();
                  }}
                  stopBot={() => this.gameRef.current.reset()}
                  isPlaying={this.state.isPlaying}
                />
              )}
            </div>
          </div>
          {showTutorial && (
            <div className="turtorial-section">
              {currentLevel < 5 ? (
                <Welcome onComplete={() => this.setState({ showTutorial: false })} />
              ) : (
                <Tutorial2 onComplete={() => this.setState({ showTutorial: false })} />
              )}
            </div>
          )}
        </div>
        {/* <div className="rotate-phone-container">
          <img
            className="rotate-phone-container__image"
            src={RotatePhone}
            alt="Rotate phone illustration"
          />
          <p className="rotate-phone-container__title">
            Turn your phone to get started
          </p>
        </div> */}
      </>
    );
  }
}

export default Level;
